import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DobryAgentBlogCategoryService} from "../../../../shared/services/dobry-agent-blog-category.service";
import {AuthService} from "../../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../../shared/services/filter.service";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {Profile} from "../../../../shared/interface/profile";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {DobryAgentBlogCategory, DobryAgentBlogTag} from "../../../../shared/interface/dobry-agent-blog-article";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {NgForm} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {Sort} from "@angular/material/sort";

@Component({
  selector: 'app-da-category-list',
  templateUrl: './da-category-list.component.html',
  styleUrls: ['./da-category-list.component.scss']
})
export class DaCategoryListComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;
  displayedColumns: string[] = ['name', 'position', 'description', 'status', 'actions'];
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  profile: Profile;
  blogCategories: DobryAgentBlogCategory[];
  totalData = 0;
  sortBy = 'position';
  sortOrder = 'asc';

  constructor(
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private dobryAgentBlogCategoryService: DobryAgentBlogCategoryService
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.dobryAgentBlogCategoryService.getBlogCategoryListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<DobryAgentBlogCategory>) => {
          this.blogCategories = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      contains$name: 'string',
      active: 'int',
      deleted: 'string'
    }, filters);
  }
  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  loadListData(): void {
    this.dobryAgentBlogCategoryService.loadList(
      this.paginator.pageIndex, this.paginator.pageSize,
      this.buildFilters(),
      {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      }
    )
    ;
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    return filters;
  }


  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  add(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }


  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }


  sortChanged($event: Sort): void {
    this.sortBy = $event.active;
    this.sortOrder = $event.direction;

    this.loadListData();

  }


  restore(blogTag: DobryAgentBlogTag): void {
    this.dobryAgentBlogCategoryService
      .confirmRestore(blogTag)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((restore: boolean) => {
        if (restore) {
          this.loadListData();
        }
      });
  }
  delete(blogTag: DobryAgentBlogTag): void {
    this.dobryAgentBlogCategoryService
      .confirmDelete(blogTag)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (deleted) {
          this.loadListData();
        }
      });
  }

  deleteWeak(uuid: string): void {
    this.dobryAgentBlogCategoryService
      .confirmDeleteWeak(uuid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (deleted) {
          this.loadListData();
        }
      });
  }

}
